import { UnauthorizedError } from '../../errors/UnauthorizedError';
import type { IEndpoint } from '../../types';

import { IUserInfoResponse, UserInfoType } from './types';

export const userInfoEndpoint: IEndpoint<UserInfoType, { totalBalance: boolean }> = {
  url: '/api/wallet/balance',
  parser: (rawResponse, { totalBalance }): UserInfoType => {
    const response = rawResponse as IUserInfoResponse;
    if (response['errorCode'] === 1) {
      throw new UnauthorizedError('userInfoEndpoint: ' + response['description']);
    }
    return {
      casinoId: response.casinoId,
      userId: response.userId,
      userType: response.userType,
      screenName: response.screenName,
      country: response.countryCode,
      enrolmentDate: response.enrollmentDate,
      hasActiveBets: response.hasActiveBets,
      ranking: response.ranking,
      points: response.points,
      balance: {
        amount: totalBalance ? Number(response.balance) + Number(response.bonusBalance) : Number(response.balance),
        bonus: totalBalance ? 0 : Number(response.bonusBalance),
        currency: response.currency,
        currencySymbol: response.currencyCode,
        currencySymbolBefore: response.currencySymbolBefore,
        updateTimestamp: Date.now(),
      },
    };
  },
  format: 'json',
};
